import type {LazyIconSetLoader, LazyIconGetter, LazyIconAsset} from './types';

export const $lazyIcon = Symbol('lazyIcon');

export function makeLazyIconGetter<T extends string = never>(
  loader: LazyIconSetLoader,
): LazyIconGetter<T> {
  return (name) => ({
    [$lazyIcon]: true,
    loader,
    name,
  });
}

export function isLazyIcon(value: unknown): value is LazyIconAsset {
  return $lazyIcon in (value as LazyIconAsset);
}
